import { addCollection } from '@iconify/vue';

function svgToIconifyBody(svgString) {
    const match = svgString.match(/<svg[^>]*>([\s\S]*)<\/svg>/i);
    if (!match) {
        return null;
    }

    return match[1].trim();
}

// Import from both light and bold directories
const lightModules = import.meta.glob('./light/*.svg', { eager: true, query: '?raw', import: 'default' });
const boldModules = import.meta.glob('./bold/*.svg', { eager: true, query: '?raw', import: 'default' });

export const customIcons = {};

// Register light icons (without suffix, as CFIcon uses bare name for light variant)
Object.entries(lightModules).forEach(([path, svgContent]) => {
    const name = path.replace('./light/', '').replace('.svg', '');
    const body = svgToIconifyBody(svgContent);

    if (body) {
        customIcons[name] = { body };
    }
});

// Register bold icons (with -bold suffix, as CFIcon appends this for bold variant)
Object.entries(boldModules).forEach(([path, svgContent]) => {
    const name = path.replace('./bold/', '').replace('.svg', '');
    const body = svgToIconifyBody(svgContent);

    if (body) {
        customIcons[`${name}-bold`] = { body };
    }
});

addCollection({
    prefix: 'custom',
    icons: customIcons,
    width: 24,
    height: 24,
});
